const templateUrl = require('./analytics.html');

function AnalyticsService($window, $document, msiConfig, merchantId, analyticsId, $templateCache) {
  function analyticsWrapper(type, params, command = 'send') {
    $window.ga(`og.${command}`, type, params);
  }

  this.init = function() {
    const script = $document[0].createElement('script');
    script.innerHTML = $templateCache.get(templateUrl);

    $document[0].body.appendChild(script);
  };

  this.setChannel = function(merchant, user) {
    $window.ga('create', analyticsId, 'auto', {
      name: 'og',
      userId: `${merchant}.${user}`
    });
  };

  this.logPageView = function() {
    analyticsWrapper('pageview', merchantId);
  };

  this.logEvent = function(action, label) {
    analyticsWrapper('event', {
      page: merchantId,
      eventCategory: merchantId,
      eventAction: action,
      eventLabel: label
    });
  };
}

AnalyticsService.$inject = ['$window', '$document', 'config', 'merchantId', 'analyticsId', '$templateCache'];

module.exports = AnalyticsService;
